export default {
  photo: "PHOTO_FILE",
  passportPhoto: "PASSPORT_FILE",
  passportBackPhoto: "PASSPORT_BACK_FILE",
  highSchoolDiplomaPhoto: "HIGH_SCHOOL_DIPLOMA_FILE",
  highSchoolDiplomaIlovaPhoto: "HIGH_SCHOOL_DIPLOMA_ILOVA_FILE",
  transcriptPhoto: "TRANSCRIPT_FILE",
  foreignLanguageProficiencyPhoto: "FOREIGN_LANGUAGE_PROFICIENCY_FILE",
  dtmAbiturientPhoto: "DTM_ABITURIENT_PHOTO",
  stajPhoto: "STAJ_FILE",
};
